/** Strings of the company and project wiki: `wikiEn` is the source, `wikiCs` must have the same keys. */
export const wikiEn = {
  wk: {
    wiki: "Wiki",
    companyTitle: "Netlion Wiki",
    companyIntro:
      "The company knowledge base — processes, onboarding and the tools we use day to day.",
    loadError: "Couldn't load the wiki from its repository: {{error}}",
    noPages: "No wiki pages yet.",
    createFirst: "Create the first page",
    edit: "Edit",
    newPage: "New Page",
    cancel: "Cancel",
    titleLabel: "Title",
    contentLabel: "Content",
    editTitle: "Edit: {{title}}",
    editNote: "Saved as a commit to the repository's wiki/ folder.",
    saveChanges: "Save Changes",
    saving: "Saving…",
    saveErrorPermission: "Couldn't save changes — you may not have permission.",
    saveError: "Couldn't save changes.",
    deleteErrorPermission: "Couldn't delete the page — you may not have permission.",
    deleteError: "Couldn't delete the page.",
    confirmDelete: "Delete this wiki page? This cannot be undone.",
    dangerZone: "Danger zone",
    deletePage: "Delete page",
    deleting: "Deleting…",
    newTitle: "New Wiki Page",
    newNote: "Saved as a file in the repository's wiki/ folder. Format: Markdown.",
    titlePlaceholder: "Page title",
    contentPlaceholder: "Write your wiki content here...",
    createPage: "Create Page",
    creating: "Creating…",
    createErrorPermission: "Couldn't create the page — you may not have permission.",
    createError: "Couldn't create the page.",
    projectWikis: "Project wikis",
    noProjects: "No projects.",
    searchLabel: "Search wiki pages",
    searchPlaceholder: "Search…",
    clearSearch: "Clear search",
    allPages: "All pages ({{count}}{{total}})",
    noMatches: "No matches.",
    noPagesShort: "No pages yet.",
  },
};

export const wikiCs: typeof wikiEn = {
  wk: {
    wiki: "Wiki",
    companyTitle: "Netlion Wiki",
    companyIntro: "Firemní znalostní báze — postupy, zaučení a nástroje, které denně používáme.",
    loadError: "Wiki se nepodařilo načíst z repozitáře: {{error}}",
    noPages: "Zatím žádné stránky wiki.",
    createFirst: "Vytvořit první stránku",
    edit: "Upravit",
    newPage: "Nová stránka",
    cancel: "Zrušit",
    titleLabel: "Název",
    contentLabel: "Obsah",
    editTitle: "Úprava: {{title}}",
    editNote: "Uloží se jako commit do složky wiki/ v repozitáři.",
    saveChanges: "Uložit změny",
    saving: "Ukládám…",
    saveErrorPermission: "Změny se nepodařilo uložit — možná nemáte oprávnění.",
    saveError: "Změny se nepodařilo uložit.",
    deleteErrorPermission: "Stránku se nepodařilo smazat — možná nemáte oprávnění.",
    deleteError: "Stránku se nepodařilo smazat.",
    confirmDelete: "Smazat tuto stránku wiki? Tuto akci nelze vrátit zpět.",
    dangerZone: "Nebezpečná zóna",
    deletePage: "Smazat stránku",
    deleting: "Mažu…",
    newTitle: "Nová stránka wiki",
    newNote: "Uloží se jako soubor do složky wiki/ v repozitáři. Formát: Markdown.",
    titlePlaceholder: "Název stránky",
    contentPlaceholder: "Sem napište obsah wiki...",
    createPage: "Vytvořit stránku",
    creating: "Vytvářím…",
    createErrorPermission: "Stránku se nepodařilo vytvořit — možná nemáte oprávnění.",
    createError: "Stránku se nepodařilo vytvořit.",
    projectWikis: "Wiki projektů",
    noProjects: "Žádné projekty.",
    searchLabel: "Hledat ve stránkách wiki",
    searchPlaceholder: "Hledat…",
    clearSearch: "Vymazat hledání",
    allPages: "Všechny stránky ({{count}}{{total}})",
    noMatches: "Nic nenalezeno.",
    noPagesShort: "Zatím žádné stránky.",
  },
};
